import { type SelectionState } from '../state/types.ts';

export function createInitialSelectionState(): SelectionState {
  return {
    mode: 'idle',
    selections: [],
    focusedCell: null,
    lastInteractionSource: null,
    activeEdit: null
  };
}
